export const COLLECTOR_PREFERENCE_KEYS = [
  "lego",
  "sneakers",
  "trading_cards",
  "figures",
  "vintage",
  "watches",
  "comics",
  "art",
] as const;

export type CollectorPreferenceKey = (typeof COLLECTOR_PREFERENCE_KEYS)[number];

export const COLLECTOR_ROLE_KEYS = ["buyer", "seller", "both"] as const;

export type CollectorRoleKey = (typeof COLLECTOR_ROLE_KEYS)[number];

export function isCollectorPreferenceKey(v: string): v is CollectorPreferenceKey {
  return (COLLECTOR_PREFERENCE_KEYS as readonly string[]).includes(v);
}

export function isCollectorRoleKey(v: string): v is CollectorRoleKey {
  return (COLLECTOR_ROLE_KEYS as readonly string[]).includes(v);
}

export function normalizePreferenceCategories(raw: string[] | null | undefined): CollectorPreferenceKey[] {
  if (!raw?.length) return [];
  const out: CollectorPreferenceKey[] = [];
  const seen = new Set<string>();
  for (const entry of raw) {
    const k = String(entry).trim();
    if (!isCollectorPreferenceKey(k) || seen.has(k)) continue;
    seen.add(k);
    out.push(k);
  }
  return out;
}
